import { useEffect, useState } from 'react';

/** `Date.now()` floored to the minute, updated on each minute boundary --
 *  the now line and the queue projections move once a minute, and
 *  nothing that reads this re-renders more often than that. */
export function useMinuteNow(): number {
  const [now, setNow] = useState(() => Math.floor(Date.now() / 60_000) * 60_000);
  useEffect(() => {
    let timer: number | undefined;
    const schedule = () => {
      const ms = Date.now();
      timer = window.setTimeout(
        () => {
          setNow(Math.floor(Date.now() / 60_000) * 60_000);
          schedule();
        },
        60_000 - (ms % 60_000) + 50,
      );
    };
    schedule();
    return () => window.clearTimeout(timer);
  }, []);
  return now;
}
